// 获取有序项目符号的索引值
import _has from 'lodash/has';
import { isParaEmpty } from '../utils';
import { TranslationBullet } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/bullet';

export const getCharaterIndex = (para, index, paragraphList) => {
    const { paragraphCharacter } = para;
    let characterIndex = 0;
    if (_has(paragraphCharacter, 'buAutoNum')) {
        characterIndex = checkCharacterIndex(para, paragraphList, 'buAutoNum', index);
    }
    return characterIndex + 1;
};
const checkLevel = (tmpLevel, tLevel, tmpPara) => tmpLevel === tLevel && !isParaEmpty(tmpPara);
const checkCharacterIndex = (para, paragraphList, value, i) => {
    let characterIndex = 0;
    const { paragraphCharacter, paragraphProps } = para;
    const tLevel = paragraphProps.level || 0;
    // 自增的才需要
    const tType = paragraphCharacter[value].type;
    // eslint-disable-next-line
    while ((i -= 1) >= 0) {
        const tmpPara = paragraphList[i];
        if (!_has(tmpPara, 'paragraphCharacter.character')) {
            break;
        }
        const tmpParagraphProps = tmpPara.paragraphProps;
        const tmpLevel = tmpParagraphProps.level || 0;

        // 1. 层级大于当前层级，直接跳过
        // 2. 层级小于当前层级，重新开始记数
        // 3. 层级等于当前层级，类型不同，开始重新计数
        // 4. 层级等于当前层级，类型相同且包含文字，计数加一
        if (tmpLevel > tLevel) continue;
        if (tmpLevel < tLevel) break;

        const tmpParagraphCharacter = tmpPara.paragraphCharacter;
        if (!tmpParagraphCharacter[value] || tmpParagraphCharacter[value].type !== tType) {
            break;
        }
        // 只有同级且有文字才加
        // eslint-disable-next-line
        if (checkLevel(tmpLevel, tLevel, tmpPara)) characterIndex++;
    }
    return characterIndex;
};
// 供单元测试用
export const testTable = {
    checkCharacterIndex,
};
// 获取无序项目符号的无障碍中文内容
export const getTranslationBuChar = (paragraphCharacter) => {
    let translationBuChar;
    if (paragraphCharacter) {
        const characterBulletChar = paragraphCharacter.character_bullet_char;
        if (characterBulletChar) {
            if (TranslationBullet[characterBulletChar]) {
                translationBuChar = TranslationBullet[characterBulletChar];
            } else {
                // 不识别的项目符号
                // eslint-disable-next-line
                translationBuChar = '项目符号';
            }
        }
    }

    return translationBuChar;
};
// 获取项目符号（包括有序和无序）
export const getProjectBullet = (paragh, paragraphList, i) => {
    let projectBullet = '';
    const translationBuChar = getTranslationBuChar(paragh.paragraphCharacter);
    const needCharacter = paragh.paragraphCharacter?.character && !paragh.paragraphCharacter?.buNone;
    if (needCharacter) {
        if (translationBuChar) {
            projectBullet = `${translationBuChar}。`;
        } else {
            const index = getCharaterIndex(paragh, i, paragraphList);
            projectBullet = `${index}。`;
        }
    }
    return projectBullet;
};
